import {
  SurveyQuestionPage_DefinitionModel_Base,
  SurveyQuestionPage_RenderableModel_Base,
  SurveySectionRenderingComponent
} from "./base";

export const TEXT_ALIGNMENT_CLASS = {
  "center": "text-center",
  "left": "text-left",
}

export type Paragraphs_SurveyQuestionPage_Options = {
  textAlignment: keyof (typeof TEXT_ALIGNMENT_CLASS);
  paragraphs: SurveySectionRenderingComponent[],
}

type Paragraphs_SurveyQuestionsPage_BaseModel = {
  kind: "paragraphs";
  options: Paragraphs_SurveyQuestionPage_Options;
}

export type Paragraphs_SurveyQuestionPage_DefinitionModel = SurveyQuestionPage_DefinitionModel_Base & Paragraphs_SurveyQuestionsPage_BaseModel

export type Paragraphs_SurveyQuestionPage_RenderableModel = SurveyQuestionPage_RenderableModel_Base & Paragraphs_SurveyQuestionsPage_BaseModel & {
  value: string
}
